import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { sendMetricsData } from 'src/app/core/core.actions';
import { TicketCandidate } from 'src/app/travelx/models/ticket-candidate.model';
import { CreateNewTicketComponent } from 'src/app/travelx/tickets/create-new-ticket/create-new-ticket.component';

@Component({
    selector: 'nova-create-ticket-menu',
    styleUrls: [],
    templateUrl: './create-ticket-menu.component.html',
    standalone: true,
    imports: [MatMenuModule, MatButtonModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateTicketMenuComponent {
    candidateId = input.required<number>();
    candidateName = input.required<string>();
    showNewSubmittal = input(false);
    onNewSubmittalClick = output<void>();

    constructor(
        private readonly _router: Router,
        private readonly _matDialog: MatDialog,
        private readonly _store: Store<unknown>
    ) {}

    onNewSubmittal(): void {
        this.onNewSubmittalClick.emit();
    }

    onTicket(): void {
        this._matDialog.open(CreateNewTicketComponent, {
            panelClass: ['nova__dialog'],
            disableClose: true,
            data: {
                candidate: {
                    id: this.candidateId(),
                    name: this.candidateName()
                } as TicketCandidate
            }
        });
    }

    createApplication(): void {
        const metricsData = { message: 'create application button was clicked' };
        this._store.dispatch(
            sendMetricsData({
                eventName: 'create-application-button-clicked',
                data: JSON.parse(JSON.stringify(metricsData))
            })
        );
        const url = `travelxnew/candidates/${this.candidateId()}/create-application`;
        this._router.navigateByUrl(url);
    }
}
